import React from "react";
import { NavLink } from "react-router-dom";

const baseClass =
  "group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-150";
const idleClass = "text-slate-300 hover:bg-white/5 hover:text-white";
const activeClass = "bg-white/10 text-white";

/**
 * Sidebar entry. `linkPath` routes inside Mobstr; `href` links to another app on
 * the same site (e.g. InterroPol) with a full page load. `tag` adds a small pill,
 * `hasNumber` a count badge. The current route is highlighted.
 */
export default function MenuItem({ children, displayName, linkPath, href, tag, hasNumber, closeSidebar }) {
  const content = (isActive) => (
    <>
      {isActive && (
        <span aria-hidden="true" className="absolute left-0 top-2 bottom-2 w-1 rounded-r bg-mobstr-purple" />
      )}
      <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center [&>svg]:h-5 [&>svg]:w-5">
        {children}
      </span>
      <span className="flex-1 whitespace-nowrap">{displayName}</span>
      {tag && (
        <span className="rounded-full bg-mobstr-purple/20 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-fuchsia-200">
          {tag}
        </span>
      )}
      {hasNumber !== undefined && (
        <span className="min-w-[1.5rem] rounded-full bg-white/10 px-2 py-0.5 text-center text-xs font-semibold tabular-nums text-white group-hover:bg-white/15">
          {hasNumber}
        </span>
      )}
    </>
  );
  return (
    <li>
      {href ? (
        <a href={href} className={`${baseClass} ${idleClass}`} onClick={closeSidebar}>
          {content(false)}
        </a>
      ) : (
        <NavLink
          to={`/${linkPath}`}
          className={({ isActive }) => `${baseClass} ${isActive ? activeClass : idleClass}`}
          onClick={closeSidebar}
        >
          {({ isActive }) => content(isActive)}
        </NavLink>
      )}
    </li>
  );
}
